import { Injectable } from '@angular/core';
import { Breadcrumb, BreadcrumbsService } from '@shared/breadcrumbs/breadcrumbs.typings';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class DataroomBreadcrumbsService implements BreadcrumbsService {
  public breadcrumbs: BehaviorSubject<Breadcrumb[]> = new BehaviorSubject(null);
  public readonly items: Observable<Breadcrumb[]> = this.breadcrumbs.asObservable();

  public updateItems(items: Breadcrumb[]): void {
    this.breadcrumbs.next(items);
  }
}
